import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { selectorArg1 } from '../utils/selectors';
import { IStoreBootstrap } from '../slices/bootstrap';

const bootstrapSelector = (rootState: RootState) => rootState.bootstrap;

export const bootstrapPropertySelector = <T extends keyof IStoreBootstrap>() =>
  createSelector(
    bootstrapSelector,
    selectorArg1<T>(),
    (bootstrap, propKey) => bootstrap[propKey],
  );

export const bootstrapTimezoneSelector = (rootState: RootState) =>
  bootstrapSelector(rootState).defaultConfig?.timezone ?? '';
